import { mapState } from 'vuex';
import NiotaClassicApiService from '../../../services/niotaClassicApiService';
import { EventBus } from '../../../services/eventbus.js';
import { themesMixin } from '../../../utils/themes';
import get from 'lodash/get';
import remove from 'lodash/remove';
export default {
  name: 'ViewNiotaClassicDevicesDeviceDetails',
  mixins: [themesMixin],
  data: function () {
    return {
      deviceId: null,
      tabItem: 'details',
      datasourceType: null,
      devicePacketsCount: 0,
      deviceData: null,
      viewPath: null,
      viewPathTab: null,
      formDialog: false,
      csvExportDialog: false,
      applications: [],
      deviceTypes: [],
      allRelevantKeys: [],
      allRelevantKeysRaw: [],
      maxPackets: 12,
      packetsLoading: false,
      devicePackets: [],
      packetIndex: 0,
      keysDatasets: {},
      parsedPackets: {},
      parsedPacketsSize: 0,
      packetsByTimestamps: {},
      isLoading: false,
      qrScanner: false,
      from: '0',
      isLoadingGraph: true,
      showLoadMorePackets: false,
      visualizeGraphsToggle: false,
      dynamicGraph: {},
      parsedPacketsOptions: {},
      application: null,
      connection: null,
      lclObjectStr: null,
      btnDisabled: false,
      parsedPacketsLimit: 10,
      loadMoreParsedPackets: false
    };
  },
  computed: {
    ...mapState('app', ['inpOutlined', 'inpFilled', 'image', 'color', 'permissions']),
    headerBG() {
      return './img/dtwin-factory1.png';
    },
    isMobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
    n1Protocol() {
      return process.env.VUE_APP_N1_API_PROTOCOL;
    },
    n1Host() {
      return process.env.VUE_APP_N1_API_HOST;
    },
    isIotHubManager() {
      return this.permissions['IotHub.manage'];
    }
  },
  watch: {
    $route() {
      this.initData();
    }
  },
  mounted() {
    this.initData();
  },
  destroyed() {
    this.teardownWebSocket();
  },
  methods: {
    breadCrumbsPath() {
      if (get(this, 'application.title') && get(this, 'application.account.name')) {
        return [this.permissions['all.manage'] ? {
          text: this.application.account.name,
          to: `/account-mgmt/${this.application.account.id}`
        } : this.application.account.name, {
          text: this.application.title,
          to: `/niota-classic/applications/${this.application.id}/details`
        }, this.deviceData.title];
      }
      return [];
    },
    initData() {
      this.deviceId = this.$route.params.deviceId;
      this.fetchDeviceDetails();
    },
    getDeviceImageUrl(image) {
      if (/^http(?:s):\/\//i.test(image)) {
        return image;
      }
      return `${process.env.VUE_APP_N1_API_PROTOCOL}://${process.env.VUE_APP_N1_API_HOST}${image}`;
    },
    fetchDeviceDetails() {
      NiotaClassicApiService.deviceGetDetails(this.deviceId).then(async res => {
        this.deviceData = res.data.device;
        if (this.deviceData.id) {
          if (get(this.deviceData, 'originator.datasource.type')) {
            this.setDatasourceType(get(this.deviceData, 'originator.datasource.type'));
          }
          if (!this.devicePackets.length) {
            this.fetchDevicePackets();
          }
          if (!this.deviceTypes.length) {
            this.deviceTypeFetchPlain();
          }
          if (!this.applications.length) {
            this.applicationsFetchPlain();
          }
          if (!this.application) {
            await this.getApplication();
          }
          EventBus.$emit('update-breadcrumbs');
        }
      }).catch(error => {
        this.deviceData = null;
        this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.notFound'), 'error');
        console.error(error);
      });
    },
    fetchDevicePackets() {
      this.packetsLoading = true;
      NiotaClassicApiService.deviceFetchPackets(this.deviceId, this.from, this.devicePackets.length).then(res => {
        if (res.data.packets.length) {
          this.setDevicePackets(res.data.packets);
          this.maxPackets = res.data.packets.length;
          this.devicePacketsCount = this.maxPackets;
        }
        if (!res.data.packets.length && this.devicePackets.length > 0) {
          this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.noMorePackets'), 'error');
          this.btnDisabled = true;
        }
        if (!res.data.packets.length && this.from !== '0') {
          this.from = '0';
          this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.noPacketsInThisPeriod'), 'error');
          this.fetchDevicePackets();
        }
      }).catch(error => {
        this.devicePackets = [];
        // this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.devicePacketsNotFound'), 'error');
        console.error(error);
      }).finally(() => this.packetsLoading = false);
    },
    deviceFetchParsedPackets() {
      this.isLoading = true;
      this.isLoadingGraph = true;
      NiotaClassicApiService.deviceFetchParsedPackets(this.deviceData.id, this.parsedPacketsOptions).then(res => {
        this.setDeviceParsedPackets(res.data);
      }).catch(error => {
        // this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.errorLoadingParsedPackets'), 'error');
        console.error(error);
      }).finally(() => {
        this.isLoading = false;
        this.isLoadingGraph = false;
      });
    },
    getApplication() {
      return NiotaClassicApiService.applicationGet(this.deviceData.applicationId).then(res => {
        this.application = res.data.application;
        this.teardownWebSocket();
        this.setupN1WebSocket(this.deviceData.id, this.application.account.data.realTimeApiKey);
      }).catch(res => {
        this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.applicationNotFound'), 'error');
        console.error(res);
      });
    },
    loadParsedPackets(options) {
      this.parsedPacketsOptions = options;
      this.deviceFetchParsedPackets();
    },
    loadParsedPacketsForVisualization(limit) {
      this.parsedPacketsLimit = limit;
      this.loadMoreParsedPackets = true;
      if (this.parsedPacketsOptions.limit) {
        this.parsedPacketsOptions.limit = limit;
      } else {
        this.parsedPacketsOptions = {
          limit
        };
      }
      this.deviceFetchParsedPackets();
    },
    deviceTypeFetchPlain() {
      NiotaClassicApiService.deviceTypeFetchPlain().then(res => {
        this.deviceTypes = res.data.devicetypes;
      }).catch(error => {
        this.deviceTypes = [];
        this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.errorFindingDeviceTypes'), 'error');
        console.error(error);
      });
    },
    applicationsFetchPlain() {
      NiotaClassicApiService.applicationsFetchPlain().then(res => {
        this.applications = res.data.applications;
      }).catch(error => {
        this.applications = [];
        this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.errorFindingApplications'), 'error');
        console.error(error);
      });
    },
    setDatasourceType(datasourceType) {
      let type = this.setJoinViewValues(datasourceType.toUpperCase());
      this.datasourceType = type;
    },
    setJoinViewValues(type) {
      type === 'FIREFLY' ? type = 'FIREFLY_MQTT' : type;
      type === 'TEMETRA' ? type = 'UDP' : type;
      type === 'DISCOVERGY' ? type = 'UDP' : type;
      return type;
    },
    viewAllDevices() {
      this.$router.push({
        path: '/niota-classic/devices'
      });
    },
    refresh() {
      this.fetchDeviceDetails();
    },
    setDevicePackets(packets) {
      this.devicePackets = [...this.devicePackets, ...packets];
      packets.forEach(packet => {
        packet.uid = this.packetIndex;
        this.packetIndex++;
      });
      // change here for parsed packets
      if (packets.length && !this.parsedPackets) {
        this.allRelevantKeys = [];
        this.keysDatasets = this.getKeysDatasets(this.devicePackets, this.allRelevantKeys, false);
        this.allRelevantKeys = this.keysDatasets.allRelevantKeys;
      }
      if (!this.application && !this.connection) {
        this.getApplication();
      }
    },
    getKeysDatasets(allPackets, allRelevantKeys, advance) {
      var datasets = []; //need to be returned
      let allRelevantKeysRaw = [];
      if (allPackets[0] && allPackets[0].source_data && allPackets[0].source_data.parsed) {
        let parsed = allPackets[0].source_data.parsed;
        let keys = Object.keys(parsed);
        keys.forEach(key => {
          if (typeof parsed[key] === 'number') {
            allRelevantKeysRaw.push(key);
            allRelevantKeys.push(advance ? `${key.toUpperCase()}*` : key.toUpperCase());
          }
        });
      }
      this.sortCaseInsensitive(allRelevantKeys);
      this.sortCaseInsensitive(allRelevantKeysRaw);
      allRelevantKeys.forEach((relevantKey, key) => {
        var currentKeyArray = [];
        var keyName = advance ? `${allRelevantKeysRaw[key]}*` : allRelevantKeysRaw[key];
        allPackets.forEach(packet => {
          currentKeyArray.push(packet.source_data.parsed[keyName]);
        });
        datasets.push([{
          label: keyName,
          data: currentKeyArray
        }]);
      });
      return {
        allRelevantKeys,
        datasets
      };
    },
    sortCaseInsensitive(array) {
      array.sort(function (a, b) {
        return a.toLowerCase().localeCompare(b.toLowerCase());
      });
    },
    getParsedPacketsSize(parsedPackets) {
      let biggestPacketLength = 0;
      Object.keys(parsedPackets).forEach(key => {
        if (parsedPackets[key].length > biggestPacketLength) {
          biggestPacketLength = parsedPackets[key].length;
        }
      });
      return biggestPacketLength;
    },
    setDeviceParsedPackets(packets) {
      this.parsedPackets = packets.data;
      if (packets.timestampsData) {
        this.packetsByTimestamps = packets.timestampsData;
      }
      this.parsedPacketsSize = this.getParsedPacketsSize(this.parsedPackets);
      if (this.loadMoreParsedPackets && this.parsedPacketsLimit > this.parsedPacketsSize) {
        this.$snack(this.$i18n_t('NiotaClassic.Devices.snacks.noMorePackets'), 'error');
      }
      let graphInput = this.graphInputs(this.parsedPackets, this.parsedPacketsSize, true);
      // change here for parsed packets
      if (this.parsedPacketsSize && !this.parsedPackets) {
        this.keysDatasets = this.getKeysDatasetsParsed(this.parsedPackets, this.allRelevantKeys, false);
        this.allRelevantKeys = this.keysDatasets.allRelevantKeys;
      }
      this.visualizeParsedPacketsGenerator(graphInput);
    },
    getKeysDatasetsParsed(parsedPackets, allRelevantKeys, advance) {
      var datasets = [];
      let allRelevantKeysRaw = [];
      Object.keys(parsedPackets).forEach(key => {
        if (parsedPackets[key].length) {
          allRelevantKeysRaw.push(key);
          allRelevantKeys.push(advance ? `${key.toUpperCase()}*` : key.toUpperCase());
        }
      });
      this.sortCaseInsensitive(allRelevantKeys);
      this.sortCaseInsensitive(allRelevantKeysRaw);
      this.allRelevantKeysRaw = allRelevantKeysRaw;
      allRelevantKeysRaw.forEach(key => {
        let typeName = get(parsedPackets[key][0], 'value_type_name', '').toLowerCase();
        if (typeName && typeName !== 'string') {
          var keyName = advance ? `${key}*` : key;
          let currentKeyArray = [];
          parsedPackets[key].forEach(packet => {
            currentKeyArray.push(packet.value);
          });
          datasets.push([{
            label: `${keyName}(${typeName || this.$i18n_t('Common.notAvailable')})`,
            data: currentKeyArray
          }]);
        } else {
          remove(allRelevantKeys, element => {
            return element.toLowerCase() === key;
          });
        }
      });
      return {
        allRelevantKeys,
        datasets
      };
    },
    graphInputs(packets, packetsLength, parsed = false) {
      var xAxisArray = this.axisGenerator(packetsLength);
      this.allRelevantKeys = [];
      var keysDatasets = parsed ? this.getKeysDatasetsParsed(packets, this.allRelevantKeys, false) : this.getKeysDatasets(packets, this.allRelevantKeys, false);
      this.allRelevantKeys = keysDatasets.allRelevantKeys;
      let keys = this.allRelevantKeys;
      var datasets = keysDatasets.datasets;
      return {
        keys,
        datasets,
        xAxisArray
      };
    },
    //generates the x axis for the graphs depending on the packets length
    axisGenerator(packetsLength) {
      var generatedArray = [];
      for (let i = 0; i < packetsLength; i++) {
        generatedArray.push(i + 1);
      }
      return generatedArray;
    },
    loadMorePackets() {
      let lastPacketIndex = this.devicePackets.length - 1;
      let lastPacket = this.devicePackets[lastPacketIndex];
      if (lastPacket !== undefined) {
        this.fetchDevicePackets();
      }
    },
    fetchDevicePacketsByDate(date) {
      this.devicePackets = [];
      this.from = date;
      this.fetchDevicePackets();
    },
    visualizeParsedPacketsGenerator(graphInput) {
      this.dynamicGraphs(graphInput.keys, graphInput.datasets, graphInput.xAxisArray);
      this.showLoadMorePackets = true;
      this.visualizeGraphsToggle = true;
    },
    dynamicGraphs(keys, datasets, axisArray) {
      keys.forEach((key, index) => {
        if (datasets[index]) {
          this.updateGraph(key, axisArray, datasets[index]);
        }
      });
    },
    updateGraph(key, labels, datasets) {
      this.dynamicGraph[key] = {
        data: datasets[0].data,
        label: datasets[0].label,
        color: this.vuetifyColorHex(),
        dataLabels: labels
      };
    },
    setupN1WebSocket(id, key) {
      this.lclObjectStr = 'Establishing connection\n';
      this.connection = new WebSocket(`ws${this.n1Protocol === 'https' ? 's' : ''}://${this.n1Host}/api/x/websocket/devices/${id}?auth=${key}`);
      const instance = this;
      this.connection.onmessage = function (event) {
        instance.lclObjectStr += `Data-Packet START:\n${event.data}\nData-Packet END\n`;
        // console.log('WS-Data:', { data: event.data });
        // instance.websocketPackets.unshift(JSON.parse(event.data));
        instance.setPacket(JSON.parse(event.data));
      };
      this.connection.onopen = function () {
        // console.log('WS: Connected');
        instance.lclObjectStr += 'Successfully connected to the websocket server\nWaiting for data...\n';
        instance.wsConnected = true;
      };
      this.connection.onerror = function (error) {
        instance.lclObjectStr += `An error occurred: ${error}\n`;
      };
      this.connection.onclose = function () {
        instance.lclObjectStr += 'Disconnected from WebSocket Server\n';
      };
    },
    teardownWebSocket() {
      if (this.connection) {
        this.connection.close();
      }
    },
    setPacket(packet) {
      if (this.from === '0') {
        this.devicePackets.unshift(packet);
      }
    },
    getDeviceTypeData() {
      let data = `${this.$i18n_t('NiotaClassic.Devices.type')}:`;
      if (get(this.deviceData, 'deviceType.title')) {
        data += get(this.deviceData, 'deviceType.title');
      } else {
        data += '-';
      }
      if (get(this.deviceData, 'deviceType.parser.type')) {
        data += `(${this.$i18n_t('NiotaClassic.Devices.parser')}:`;
        data += `${get(this.deviceData, 'deviceType.parser.type')})`;
      }
      return data;
    }
  }
};